import { render, staticRenderFns } from "./TipoPedidoList.vue?vue&type=template&id=fa4cdd06&scoped=true"
import script from "./TipoPedidoList.vue?vue&type=script&lang=js"
export * from "./TipoPedidoList.vue?vue&type=script&lang=js"
import style0 from "./TipoPedidoList.vue?vue&type=style&index=0&id=fa4cdd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4cdd06",
  null
  
)

export default component.exports